<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>RIWAYAT GAJI BERKALA</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>

      <div
        slot="gaji_pokok"
        slot-scope="props">
        <j-currency
          :value="Number(props.row.gaji_pokok)"
          :options="exampleOptionCurrency"/>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Riwayat Gaji Berkala</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.pangkat_golongan.$error}">
            <label> Pangkat Golongan </label>
            <j-input
              v-model="$v.data_master.pangkat_golongan.$model"
              placeholder="Pangkat Golongan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_sk.$error}">
            <label> Nomor SK </label>
            <j-input
              v-model="$v.data_master.no_sk.$model"
              placeholder="Nomor SK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_sk.$error}">
            <label> Tanggal SK Berkala </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_sk.$model"
              placeholder="Tgl SK Berkala"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_kgb.$error}">
            <label> TMT SK Berkala </label>
            <j-datepicker
              v-model="$v.data_master.tmt_kgb.$model"
              placeholder="TMT SK Berkala"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_tahun.$error}">
            <label> Masa Kerja (Tahun) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_tahun.$model"
              type="number"
              placeholder="Fakultas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_bulan.$error}">
            <label> Masa Kerja (Bulan) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_bulan.$model"
              type="number"
              placeholder="Masa Kerja (Bulan)"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.gaji_pokok.$error}">
            <label> Gaji Pokok </label>
            <j-currency
              v-model="$v.data_master.gaji_pokok.$model"
              :options="exampleOptionCurrency"
              :input_mode="true"
              placeholder="Gaji Pokok"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Riwayat Gaji Berkala</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.pangkat_golongan.$error}">
            <label> Pangkat Golongan </label>
            <j-input
              v-model="$v.data_master.pangkat_golongan.$model"
              :disabled="readOnly"
              placeholder="Pangkat Golongan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_sk.$error}">
            <label> Nomor SK </label>
            <j-input
              v-model="$v.data_master.no_sk.$model"
              :disabled="readOnly"
              placeholder="Nomor SK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_sk.$error}">
            <label> Tanggal SK Berkala </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_sk.$model"
              :disabled="readOnly"
              placeholder="Tgl SK Berkala"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_kgb.$error}">
            <label> TMT SK Berkala </label>
            <j-datepicker
              v-model="$v.data_master.tmt_kgb.$model"
              :disabled="readOnly"
              placeholder="TMT SK Berkala"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_tahun.$error}">
            <label> Masa Kerja (Tahun) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Fakultas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_bulan.$error}">
            <label> Masa Kerja (Bulan) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_bulan.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Masa Kerja (Bulan)"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.gaji_pokok.$error}">
            <label> Gaji Pokok </label>
            <j-currency
              v-model="$v.data_master.gaji_pokok.$model"
              :options="exampleOptionCurrency"
              :input_mode="true"
              :disabled="readOnly"
              placeholder="Gaji Pokok"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jGajiBerkala',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['pangkat_golongan', 'no_sk', 'tanggal_sk', 'tmt_kgb', 'masa_kerja_tahun', 'masa_kerja_bulan', 'gaji_pokok'],
      options: {
        headings: {
          pangkat_golongan: 'PANGKAT GOLONGAN',
          no_sk: 'NOMOR SK',
          tanggal_sk: 'TANGGAL SK BERKALA',
          tmt_kgb: 'TMT SK BERKALA',
          masa_kerja_tahun: 'MASA KERJA (TAHUN)',
          masa_kerja_bulan: 'MASA KERJA (BULAN)',
          gaji_pokok: 'GAJI POKOK',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['pangkat_golongan', 'no_sk', 'tanggal_sk', 'tmt_kgb', 'masa_kerja_tahun', 'masa_kerja_bulan', 'gaji_pokok'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListGajiBerkala(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        pangkat_golongan: '',
        no_sk: '',
        tanggal_sk: null,
        tmt_kgb: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
        gaji_pokok: null,
      },
      exampleOptionCurrency: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: 'Rp',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '99999999999999',
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createGajiBerkala', 'updateGajiBerkala', 'deleteGajiBerkala']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        pangkat_golongan: '',
        no_sk: '',
        tanggal_sk: null,
        tmt_kgb: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
        gaji_pokok: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        pangkat_golongan: '',
        no_sk: '',
        tanggal_sk: null,
        tmt_kgb: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
        gaji_pokok: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        pangkat_golongan: param.row.pangkat_golongan,
        no_sk: param.row.no_sk,
        tanggal_sk: param.row.tanggal_sk,
        tmt_kgb: param.row.tmt_kgb,
        masa_kerja_tahun: Number(param.row.masa_kerja_tahun),
        masa_kerja_bulan: Number(param.row.masa_kerja_bulan),
        gaji_pokok: Number(param.row.gaji_pokok),
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tanggal_sk = params.tanggal_sk ? this.$moment(params.tanggal_sk).format('YYYY-MM-DD') : '';
        params.tmt_kgb = params.tmt_kgb ? this.$moment(params.tmt_kgb).format('YYYY-MM-DD') : '';
        this.createGajiBerkala(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tanggal_sk = params.tanggal_sk ? this.$moment(params.tanggal_sk).format('YYYY-MM-DD') : '';
        params.tmt_kgb = params.tmt_kgb ? this.$moment(params.tmt_kgb).format('YYYY-MM-DD') : '';
        this.updateGajiBerkala(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteGajiBerkala(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        pangkat_golongan: { required },
        no_sk: { required },
        tanggal_sk: { required },
        tmt_kgb: { required },
        masa_kerja_tahun: { required },
        masa_kerja_bulan: { required },
        gaji_pokok: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jGajiBerkala.vue